var map = {
	"./en/card_3_1.png": "CSpO",
	"./es/card_3_1.png": "JhvU",
	"./pt/card_3_1.png": "RWp2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XY4f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/card_3_1\.png$
// module id = XY4f
// module chunks = 0